import { DEFAULT_BORDER } from "../const/excel.const";
import { applyBorderEachCell } from "../utils/apply-border-each-cell";
import { CELL_FORMAT } from "../utils/add-num-format";
export const SUMMARY_HEADER_CELLS = [
    "No.",
    "구분",
    "관리코드",
    "개수",
    "소계",
    "비고",
];
// 요약 시트 데이터 시작 행
const SUMMARY_DATA_START_ROW = 5;
export const addSummaryTitle = (ws, options = {
    columnWidths: [6, 18, 12, 12, 18, 15],
    title: "파이온일렉트릭(주) 자재(재고 자산) 현황",
}) => {
    options.columnWidths?.forEach((width, index) => {
        ws.getColumn(index + 1).width = width;
    });
    ws.mergeCells("A1:F2");
    const titleCell = ws.getCell("A1");
    titleCell.value = options?.title;
    titleCell.font = {
        size: 16,
        bold: true,
    };
    titleCell.alignment = {
        horizontal: "center",
        vertical: "middle",
        shrinkToFit: true,
    };
    titleCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: {
            argb: "F2F2F2",
        },
    };
    titleCell.border = DEFAULT_BORDER;
    // 빈 행 추가
    const cell = ws.addRow([]);
    cell.border = DEFAULT_BORDER;
};
export const addSummaryHeaderRow = (ws) => {
    const headerRow = ws.addRow(SUMMARY_HEADER_CELLS);
    headerRow.font = { bold: true };
    headerRow.alignment = { horizontal: "center", vertical: "middle" };
    const headerRowNumber = headerRow.number;
    SUMMARY_HEADER_CELLS.forEach((_cell, index) => {
        const headerCell = ws.getCell(headerRowNumber, index + 1);
        headerCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFE6E6E6" },
        };
    });
    applyBorderEachCell(headerRow);
};
/**
 * @description 요약 시트의 본문 행 추가 (수식으로 각 시트의 Q2, R2 참조)
 * @param ws 워크시트
 * @param rowData 행 데이터
 * @param sheetName 참조할 시트 이름 (3번째 시트부터)
 */
export const addSummaryBodyRow = (ws, rowData, sheetName) => {
    const row = ws.addRow([
        rowData.no,
        rowData.division,
        rowData.code,
        null,
        null,
        "",
    ]);
    const noCell = row.getCell(1);
    noCell.alignment = { horizontal: "center", vertical: "middle" };
    const codeCell = row.getCell(3);
    codeCell.alignment = { horizontal: "center", vertical: "middle" };
    // 개수: 해당 시트의 Q2 참조
    const quantityCell = row.getCell(4);
    quantityCell.value = {
        formula: `'${sheetName}'!Q2`,
    };
    quantityCell.numFmt = CELL_FORMAT.quantity;
    quantityCell.alignment = { horizontal: "right" };
    // 소계: 해당 시트의 R2 참조
    const amountCell = row.getCell(5);
    amountCell.value = {
        formula: `'${sheetName}'!R2`,
    };
    amountCell.numFmt = CELL_FORMAT.price;
    amountCell.alignment = { horizontal: "right" };
    applyBorderEachCell(row);
};
/**
 * @description 요약 시트의 합계 행 추가 (SUM 수식 사용)
 * @param ws 워크시트
 * @param dataRowCount 데이터 행 개수
 */
export const addSummaryTotalRow = (ws, dataRowCount) => {
    const dataEndRow = SUMMARY_DATA_START_ROW + dataRowCount - 1;
    const totalRow = ws.addRow(["합계", null, null, null, null, ""]);
    ws.mergeCells(`A${totalRow.number}:C${totalRow.number}`);
    const totalLabelCell = ws.getCell(`A${totalRow.number}`);
    totalLabelCell.value = "합계";
    totalLabelCell.alignment = { horizontal: "center", vertical: "middle" };
    totalRow.font = { bold: true };
    // 개수 합계: D열의 SUM 수식
    const quantityTotalCell = totalRow.getCell(4);
    quantityTotalCell.value = {
        formula: `SUM(D${SUMMARY_DATA_START_ROW}:D${dataEndRow})`,
    };
    quantityTotalCell.numFmt = CELL_FORMAT.quantity;
    quantityTotalCell.alignment = { horizontal: "right" };
    // 소계 합계: E열의 SUM 수식
    const amountTotalCell = totalRow.getCell(5);
    amountTotalCell.value = {
        formula: `SUM(E${SUMMARY_DATA_START_ROW}:E${dataEndRow})`,
    };
    amountTotalCell.numFmt = CELL_FORMAT.price;
    amountTotalCell.alignment = { horizontal: "right" };
    const tableRowNumber = totalRow.number;
    for (let index = 0; index < 6; index++) {
        const tableCell = ws.getCell(tableRowNumber, index + 1);
        tableCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFF7EAD7" },
        };
    }
    applyBorderEachCell(totalRow);
};
